import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { FormSelect } from '../Form'
import type { FormSelectValue } from '@/interfaces'
import { CalendarDaysIcon } from '@heroicons/vue/24/solid'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormYearPicker',
  props: /*@__PURE__*/_mergeModels({
    startYear: { default: () => (new Date().getFullYear()) },
    placeholder: {}
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const modelValue = _useModel<FormSelectValue>(__props, "modelValue");



const options = computed(() => Array.from({ length: new Date().getFullYear() - __props.startYear + 1 }, (_, i) => __props.startYear + i).map(year => {
  return {
    value: year % 100,
    label: year.toString(),
    icon: CalendarDaysIcon
  };
}).reverse());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FormSelect), {
    placeholder: _ctx.placeholder,
    options: options.value,
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
  }, null, 8, ["placeholder", "options", "modelValue"]))
}
}

})